import React from "react";
import { Input, Label, FormGroup } from "reactstrap";

const CustomInputField = (props) => {
  const {
    name,
    onChange,
    onBlur,
    touched,
    type,
    errors,
    placeholder,
    value,
    label,
    errorBorder = true,
    className = "has-label",
    unit,
    ...rest
  } = props;
  return (
    <div className="d-flex align-items-center gap-5 ">
      <div className="custom_input_field flex-grow-1">
        <FormGroup
          className={`${className}  ${
            errorBorder
              ? touched[name] && errors[name]
                ? "has-danger"
                : touched[name] && !errors[name]
                ? "has-success"
                : ""
              : ""
          }`}
        >
          {label && (
            <Label
              className="d-block w-100 text-left mb-0 text-capitalize"
              htmlFor={name}
            >
              {label}
            </Label>
          )}
          <Input
            id={name}
            name={name}
            placeholder={placeholder}
            type={type}
            onChange={onChange}
            onBlur={onBlur}
            value={value?.[name]}
            {...rest}
          />
        </FormGroup>
        {touched[name] && errors[name] && (
          <span className="error text-danger">{errors[name]}</span>
        )}
      </div>
      {unit && (
        <span className="unit font-weight-bold font-size-xl">{unit}</span>
      )}
    </div>
  );
};

export default CustomInputField;
